/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { FetchItOutput } from "./fetchIt";

type Success<T> = { readonly tag: "successful" } & {
  readonly parsed: T;
};
type NonSuccess<U> = (
  | { readonly tag: "informational" }
  | { readonly tag: "redirection" }
  | { readonly tag: "client-error" }
  | { readonly tag: "server-error" }
  | { readonly tag: "data-error" }
) & { readonly parsed: U };

export type FetchOutput<T, U> = Success<T> | NonSuccess<U>;

export function fetchResultCasting<SuccessT, NonSuccessT>(
  result: FetchItOutput,
  parsed: unknown
) {
  switch (result.tag) {
    case "client-error":
    case "informational":
    case "redirection":
    case "server-error":
    case "data-error":
      return {
        tag: result.tag,
        parsed: parsed as NonSuccessT,
      };
    case "successful":
      return {
        tag: result.tag,
        parsed: parsed as SuccessT,
      };
  }
}
